import moment from "moment";
const { db } = require("../../js/firebaseConfig");
const NotificacionesDB = db.collection("notificaciones");

const actualizarNotificacionDoctor = async (idNotificacion) => await NotificacionesDB.doc(idNotificacion).update({
    visto_doctor: true,
    actualizado_el: moment().format("x")
});

const actualizarPushNotificaciones = async (notificacion) => await NotificacionesDB.doc(notificacion.id).update({
    notificado: true
});

const actualizarNotificacion = async (idNotificacion) => await NotificacionesDB.doc(idNotificacion).update({
    visto: true,
    actualizado_el: moment().format("x")
});

export {
    actualizarNotificacion,
    actualizarNotificacionDoctor,
    actualizarPushNotificaciones
};



// WEBPACK FOOTER //
// ./src/apiService/request/Notificaciones.js